import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router'
import get from 'lodash/get'
import values from 'lodash/values'
import Decimal from 'decimal.js'

import { show, types } from 'store/modals'
import { selectMultiVendorOrders } from 'pages/order/modules/multi.vendor.order'
import { selectInfoById } from 'pages/vendor/modules/info'
import { isVenueUrl } from 'utils/url'
import { loadDiscounts } from 'pages/vendor/modules/menu'

export default compose(
  withRouter,
  connect((state) => ({ vendorId: get(state, 'vendor.info.info.id') })),
  connect(
    (state, props) => {
      const totalSingleOrders = values(get(state, 'order.orders'))
        .reduce((prev, cur) => [...prev, ...get(cur, 'orders', [])], [])
        .reduce((acc, x) => acc.plus(get(x, 'quantity')), new Decimal(0))
        .toNumber()

      const multiVendorOrder = selectMultiVendorOrders(state)

      const totalMultiVendorOrders = multiVendorOrder
        .reduce((prev, cur) => [...prev, ...get(cur, 'orders', [])], [])
        .reduce((acc, x) => acc.plus(get(x, 'quantity')), new Decimal(0))
        .toNumber()

      const orderParty = get(
        state,
        `orderParty.parties.${props.vendorId}`,
        null,
      )

      return {
        totalSingleOrders,
        totalMultiVendorOrders,
        orderParty,
        venueDetails: selectInfoById(state, props.vendorId),
      }
    },

    (dispatch, { location, vendorId }) => ({
      showLoginModal: () =>
        dispatch(
          show(types.AUTH, {
            hasGuestCheckoutEnabled: false,
            handleSuccess: () => {
              if (isVenueUrl(location.pathname)) {
                dispatch(loadDiscounts(vendorId))
              }
            },
          }),
        ),
    }),
  ),
)
